import React from 'react';

import { flagStyles } from '../settings';

const SvgIM = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2448px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgIM;
